import type { UiNode } from '@ory/client';
import type { MfaMethod } from './session-adapter.type';

/**
 * Ory UI Nodes の便利I/F（Server Driven UI の ui.nodes を扱いやすくするAdapter）
 *
 * - `ui.nodes` を group 単位で扱う
 * - `default` を除いた group の抽出
 * - MFA method 選択の補助（selected/preferred/fallback）
 */
export class NodesAdapter {
  private readonly _nodes: ReadonlyArray<UiNode>;
  constructor(nodes: ReadonlyArray<UiNode>) {
    this._nodes = nodes;
  }
  get raw(): ReadonlyArray<UiNode> {
    return this._nodes;
  }
  get nodes(): ReadonlyArray<UiNode> {
    return this._nodes;
  }

  /**
   * MFA method の group ID の一覧を返す
   *
   * - `default` を除いた group の一覧を返す
   * - 重複は除外（先に出た順を維持）
   * - `totp` と `code` のみを返す
   *
   * @returns MFA method の group ID の一覧
   */
  get mfaMethodGroupIds(): Array<MfaMethod> {
    const result: Array<MfaMethod> = [];
    const seen = new Set<MfaMethod>();
    for (const node of this._nodes) {
      const group = node.group ?? 'default';
      if (group === 'default' || group !== 'totp' && group !== 'code') continue;
      if (seen.has(group as MfaMethod)) continue;
      seen.add(group as MfaMethod);
      result.push(group as MfaMethod);
    }
    return result;
  }

  /**
   * MFA method 選択が必要かどうか
   *
   * mfaMethodGroupIdsが2つ以上ならtrue
   */
  get shouldShowMfaMethodSelect(): boolean {
    return this.mfaMethodGroupIds.length >= 2;
  }
}